import { Routes } from '@angular/router';
import { ParamEmailsComponent } from './param-emails/param-emails.component';
import { SuiviEmailsComponent } from './suivi-emails/suivi-emails.component';

export const EMAILS_ROUTE_DATA = {
    roles: ['ORGANISME'],
    domaines: ['VIN', 'ANPP'],
    menu: {
        icon: 'envelope',
        libelle: 'menu.administration-emails'
    }
};

export const EMAILS_ROUTE_ADMIN_DATA = {
    roles: ['ADMIN'],
    domaines: ['VIN', 'ANPP'],
    menu: {
        icon: 'envelope',
        libelle: 'menu.administration-param-emails'
    }
};

export const EMAILS_ROUTES: Routes = [
    {
        path: '', component: SuiviEmailsComponent    }
];

export const EMAILS_ADMIN_ROUTES: Routes = [
    {
        path: '', component: ParamEmailsComponent    }
];
